import { SearchIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const LegacySearchButton = () => {
  const handleSearchClick = () => {
    window.location.search = '&searchFilters=SETTINGS&preFiltered=true';
  };
  return /*#__PURE__*/_jsx(IconButton, {
    use: "link",
    onClick: handleSearchClick,
    tooltip: I18n.text('settings-ui-nav.searchButtonLabel'),
    children: /*#__PURE__*/_jsx(SearchIcon, {})
  });
};